import {
  EnumTagSemanticoDTOElementoRicerca,
  TagSemanticoDTO,
} from '@framework/api-client';
import {
  ISemanticFieldSearch,
  SemanticFieldSearchOperator,
} from './ISemanticFieldSearch';
import {
  searchableFieldFromName,
  searchableFieldToName,
} from './mapSemanticTagsToSearchableFields';

function getSemanticTagSearchable(
  semanticTag: TagSemanticoDTO,
  queryList: ISemanticFieldSearch[],
) {
  if (!semanticTag.nome) return {};
  // Estraggo un singolo valore e lo imposto come filtro di ricerca
  if (
    semanticTag.elementoRicerca ===
      EnumTagSemanticoDTOElementoRicerca.RICERCA_LIBERA ||
    semanticTag.elementoRicerca ===
      EnumTagSemanticoDTOElementoRicerca.RICERCA_CON_MENU_TENDINA
  ) {
    const query = queryList.find(q => q.chiave === semanticTag.id);
    if (!query) return {};
    return { [semanticTag.nome]: query.valore };
  }
  // Estraggo entrambi i valori dell'intervallo impostando i filtri appositi ("dal", "al")
  if (
    semanticTag.elementoRicerca ===
    EnumTagSemanticoDTOElementoRicerca.RICERCA_PER_INTERVALLO
  ) {
    const query = queryList.filter(q => q.chiave === semanticTag.id);
    if (query.length === 0) return {};
    const result: Record<string, any> = {};
    const from = query.find(
      q => q.operatore === SemanticFieldSearchOperator.GREATER_OR_EQUAL,
    );
    const to = query.find(
      q => q.operatore === SemanticFieldSearchOperator.LESSER_OR_EQUAL,
    );

    if (from) {
      result[searchableFieldFromName(semanticTag.nome)] = from.valore;
    }
    if (to) {
      result[searchableFieldToName(semanticTag.nome)] = to.valore;
    }

    return result;
  }

  return {};
}

/**
 * Parsa la query di ricerca e ritorna la versione "searchable" con tutte le chiavi in root
 */
export function parseSemanticTagSearchable<
  T extends { campiSemantici?: string },
>(
  query: T,
  semanticTags: TagSemanticoDTO[] | null | undefined,
): Record<string, any> {
  if (!semanticTags || semanticTags.length === 0) return query;

  const { campiSemantici, ...staticValues } = query;

  const semanticTagQueryList: ISemanticFieldSearch[] = campiSemantici
    ? JSON.parse(campiSemantici)
    : [];

  const semanticTagSearchableList = semanticTags.map(s =>
    getSemanticTagSearchable(s, semanticTagQueryList ?? []),
  );

  const values = {
    ...staticValues,
    ...Object.assign({}, ...semanticTagSearchableList),
  };

  return values;
}
